import * as React from "react";
import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input-new/Input";

const SellerCompanyInfo = ({data, handleChangeInput, handleChangeDropdown, viewMode, deleted}) => {
    function getCompanyZIP()
    {
        if(viewMode == true && typeof data.COMPANY_ZIP !== 'undefined' && data.COMPANY_ZIP != null && data.COMPANY_ZIP.length < 5)
        {
            data.COMPANY_ZIP = '0'.repeat(5 - data.COMPANY_ZIP.length) + data.COMPANY_ZIP
        }
        if(data.COMPANY_ZIP == null || data.COMPANY_ZIP == '00000' || data.COMPANY_ZIP == '')
        {
            data.COMPANY_ZIP = ''
        }
        return data.COMPANY_ZIP;
    }
    return (
        <div className="Seller-company-info">
            <div className="Seller-company-info_column">
                <Input
                    className="Seller-company-info_column_item"
                    name="COMPANY_NAME"
                    label="Company Name"
                    value={data.COMPANY_NAME}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Seller-company-info_column_item"
                    name="COMPANY_ADDRESS"
                    label="Company Address"
                    value={data.COMPANY_ADDRESS}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Seller-company-info_column_item"
                    name="COMPANY_CITY"
                    label="City"
                    value={data.COMPANY_CITY}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Seller-company-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.COMPANY_STATE}
                    valueKey="COMPANY_STATE"
                    label="State"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input  
                    className="Seller-company-info_column_item"
                    name="COMPANY_ZIP"
                    label="Zip"
                    value= {getCompanyZIP()}                               
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
        </div>
    );
};

export default SellerCompanyInfo;
